/* eslint-disable react-hooks/exhaustive-deps */
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { useModule } from '../module/module';
import {
  ENDPOINT_ACTIVE_INTERVIEWS,
  ENDPOINT_ANSWER_INTERVEW,
  ENDPOINT_DELETE_INTERVIEW,
  ENDPOINT_EVALUATE_BY_CCE_SCORE,
  ENDPOINT_GENERATE_CERTIFICATE,
  ENDPOINT_HAS_AWAITING_EVALUATION,
  ENDPOINT_INTERVIEWS,
  ENDPOINT_INTERVIEWS_BY_ID,
  ENDPOINT_INTERVIEWS_BY_USER_AUTH,
  ENDPOINT_INTERVIEWS_MODULE,
  ENDPOINT_INTERVIEWS_PUBLIC,
  ENDPOINT_INTERVIEWS_REGISTRATION_DATA,
  ENDPOINT_LAST_INTERVIEW,
  ENDPOINT_MIGRATE_INTERVIEWS,
  ENDPOINT_PENDING_INTERVIEW,
  ENDPOINT_REALIZE_INTERVIEWS,
  ENDPOINT_SEND_INTERVIEW_CERTIFICATE,
  ENDPOINT_SET_MANAGER_RESPONSABILITY,
  ENDPOINT_UNDO_INTERVIEWS,
  ENDPOINT_UPDATE_ACEPTED_TERM_CONDITION,
  ENDPOINT_UPDATE_CONDITIONS_USE,
  ENDPOINT_UPDATE_VIEW_VIDEO_CONDITION,
  ENDPOINT_VERIFY_HAS_ANY_FILTER_ACTIVE,
  ENDPOINT_VISUALIZAR_NOTAS_E_RESPOSTAS,
} from './constants';

export function useInterviewService() {
  const { moduleSelected } = useModule();

  const { backendGet, backendPost, backendPut, backendPatch, backendGetBlob } =
    Sebrae.useBackend();

  // const { fetchData, data, loading, error } = Sebrae.usePagination(
  //   `${ENDPOINT_INTERVIEWS_MODULE}/${moduleSelected?.id}`,
  // );

  const { fetchData, data, loading, error } = Sebrae.usePagination(
    `v1/interviews/search-interviews/${moduleSelected?.id ?? 1}`,
  );

  const findActiveInterviewByCpf = React.useCallback(
    (cpf = '') => backendGet(`${ENDPOINT_ACTIVE_INTERVIEWS}/${cpf}`),
    [backendGet],
  );

  const findInterviewByCpf = React.useCallback(
    (cpf = '') => backendGet(`${ENDPOINT_INTERVIEWS}/candidate/${cpf}`),
    [backendGet],
  );

  const findInterviewByAdm = React.useCallback(
    (id) => backendGet(`${ENDPOINT_INTERVIEWS_BY_ID}/${id}`),
    [],
  );

  const findValidatePreRegistration = React.useCallback(
    (moduleId = 1, cpf = '') =>
      backendGet(
        `${ENDPOINT_INTERVIEWS_MODULE}/${moduleId}/candidate/${cpf}/validate-pre-registration`,
      ),
    [backendGet],
  );

  const serviceMigrateInterview = React.useCallback(
    ({ cpf = '', moduleOrigin = '', moduleDestiny = '' }) =>
      backendGet(
        `${ENDPOINT_MIGRATE_INTERVIEWS}/cpf/${cpf}?moduleOrigin=${moduleOrigin}&moduleDestiny=${moduleDestiny}`,
      ),
    [backendGet],
  );

  const verifyHasAnyFilterActive = React.useCallback(
    () => backendGet(`${ENDPOINT_VERIFY_HAS_ANY_FILTER_ACTIVE}`),
    [backendGet],
  );

  const findLastInterviewByCpfAndModule = React.useCallback(
    (cpf = '', moduleId) =>
      backendGet(
        `${ENDPOINT_INTERVIEWS_MODULE}/${moduleId}/cpf/${cpf}/last-interview`,
      ),
    [backendGet],
  );

  const certificateDate = React.useCallback(
    (module, cpf = '') =>
      backendGet(`${ENDPOINT_INTERVIEWS_MODULE}/${module}/certificate/${cpf}`),
    [backendGet],
  );

  const getListInterviewOfCandidate = React.useCallback(
    (idModule, id) =>
      backendGet(
        `${ENDPOINT_INTERVIEWS_MODULE}/${idModule}/candidate/${id}/historic`,
      ),
    [backendGet],
  );

  const findInterviewById = React.useCallback(
    (id) => backendGet(`${ENDPOINT_INTERVIEWS}/${id}`),
    [backendGet],
  );

  const validateNewInterviewByExpiredStatus = React.useCallback(
    (id, moduleId, cpf) =>
      backendGet(`${ENDPOINT_INTERVIEWS}/${id}/module/${moduleId}/cpf/${cpf}`),
    [backendGet],
  );

  const getLastInterview = React.useCallback(
    (cpf = '') =>
      backendGet(`${ENDPOINT_LAST_INTERVIEW}/${cpf}/last-valid-interview`),
    [backendGet],
  );

  const findInterviewByIdPublic = React.useCallback(
    (id) => backendGet(`public/${ENDPOINT_INTERVIEWS_PUBLIC}/${id}/status`),
    [backendGet],
  );

  const removeMask = React.useCallback((field) => {
    return field.replace(/[^\d]/g, '');
  }, []);

  const save = React.useCallback(
    (interview = {}) => {
      interview.candidate.cpf = removeMask(interview.candidate.cpf);
      interview.phone = removeMask(interview.phone);

      return interview.id
        ? backendPut(`${ENDPOINT_INTERVIEWS}/${interview.id}`, interview)
        : backendPost(`${ENDPOINT_INTERVIEWS}`, interview);
    },
    [backendPost, backendPut, removeMask],
  );

  const generateCertificate = React.useCallback(
    (data = {}) => {
      return backendPost(`${ENDPOINT_GENERATE_CERTIFICATE}`, data);
    },
    [backendPost],
  );

  const pendingInterview = React.useCallback(
    (data = {}) => {
      return backendPost(`${ENDPOINT_PENDING_INTERVIEW}`, data);
    },
    [backendPost],
  );

  const sendInterviewCertificate = React.useCallback(
    (data = {}) => {
      return backendPost(`${ENDPOINT_SEND_INTERVIEW_CERTIFICATE}`, data);
    },
    [backendPost],
  );

  const updateBasicData = React.useCallback(
    (interview = {}) => {
      interview.candidate.cpf = removeMask(interview.candidate.cpf);
      interview.phone = removeMask(interview.phone);

      return backendPut(
        `${ENDPOINT_INTERVIEWS}/${interview.id}/candidate`,
        interview,
      );
    },
    [backendPut, removeMask],
  );

  const addHiglight = React.useCallback(
    (id) => {
      return backendPut(`${ENDPOINT_INTERVIEWS}/${id}/add-highligth`);
    },
    [backendPut],
  );

  const deleteinterview = React.useCallback(
    (moduleId, cpf) => {
      return backendPut(
        `${ENDPOINT_DELETE_INTERVIEW}/cpf/${cpf}/module/${moduleId}/logical-delete`,
      );
    },
    [backendPut],
  );

  const extendInterview = React.useCallback(
    (idInterview) => {
      return backendPut(
        `${ENDPOINT_INTERVIEWS}/${idInterview}/extend-interview`,
      );
    },
    [backendPut],
  );

  const putEvaluateByCceScore = React.useCallback(
    (data) => {
      return backendPut(`${ENDPOINT_EVALUATE_BY_CCE_SCORE}`, data);
    },
    [backendPut],
  );

  const removeHiglight = React.useCallback(
    (id) => {
      return backendPut(`${ENDPOINT_INTERVIEWS}/${id}/remove-highligth`);
    },
    [backendPut],
  );

  const undoDesist = React.useCallback(
    (id) => {
      return backendPost(`${ENDPOINT_UNDO_INTERVIEWS}/${id}`);
    },
    [backendPost],
  );

  const realizeDesist = React.useCallback(
    (id) => {
      return backendPost(`${ENDPOINT_REALIZE_INTERVIEWS}/${id}`);
    },
    [backendPost],
  );

  const deleteCertificate = React.useCallback(
    (id, justificationOfExclusion) => {
      return backendPut(`${ENDPOINT_INTERVIEWS}/${id}/certificate`, {
        justificationOfExclusion,
      });
    },
    [backendPut],
  );

  const getFilters = React.useCallback(
    (moduleId, filter) =>
      backendGet(`${ENDPOINT_INTERVIEWS}/module/${moduleId}/filters`, {
        ...filter,
      }),
    [backendGet],
  );

  const getInterviewBoardForCategory = React.useCallback(
    (moduleId, uf) =>
      backendGet(
        `${ENDPOINT_INTERVIEWS_MODULE}/${moduleId}/board-interview-for-category`,
        { uf: uf || undefined },
      ),
    [backendGet],
  );

  const getJustificationResultUnfit = React.useCallback(
    (id) =>
      backendGet(`${ENDPOINT_INTERVIEWS}/${id}/justification-result-unfit`),
    [backendGet],
  );

  const getUrlCertificate = React.useCallback(
    (id) => backendGet(`${ENDPOINT_INTERVIEWS}/${id}/certificate`),
    [backendGet],
  );

  const getRegistrationDataBoard = React.useCallback(
    (id) => backendGet(`${ENDPOINT_INTERVIEWS_REGISTRATION_DATA}`, { ids: id }),
    [backendGet],
  );

  const getUrlDownloadCertificate = React.useCallback(
    (id) =>
      backendGetBlob(`${ENDPOINT_INTERVIEWS}/certificate/pdf`, { ids: id }),
    [backendGetBlob],
  );

  const updateConditionsUse = React.useCallback(
    (id, conditions) =>
      backendPatch(`${ENDPOINT_UPDATE_CONDITIONS_USE}/${id}`, {}, conditions),
    [backendPatch],
  );

  const updateViewVideoCondition = React.useCallback(
    (id, condition) =>
      backendPatch(
        `${ENDPOINT_UPDATE_VIEW_VIDEO_CONDITION}/${id}`,
        {},
        condition,
      ),
    [backendPatch],
  );

  const updateAceptedTermCondition = React.useCallback(
    (id, condition) =>
      backendPatch(
        `${ENDPOINT_UPDATE_ACEPTED_TERM_CONDITION}/${id}`,
        {},
        condition,
      ),
    [backendPatch],
  );

  const getNotasRespostas = React.useCallback(
    (id) => backendGet(`${ENDPOINT_VISUALIZAR_NOTAS_E_RESPOSTAS}/${id}`),
    [backendGet],
  );

  const getRespostaUser = React.useCallback(
    (id) => backendGet(`${ENDPOINT_ANSWER_INTERVEW}/${id}`),
    [backendGet],
  );

  const getInterviewByuserAuth = React.useCallback(
    () => backendGet(ENDPOINT_INTERVIEWS_BY_USER_AUTH),
    [],
  );

  const hasAlertAwaitinAvaliation = React.useCallback(
    () => backendGet(ENDPOINT_HAS_AWAITING_EVALUATION),
    [backendGet],
  );

  const addManagerResponsability = React.useCallback(
    ({ idInterview, idMnagerResponsible }) =>
      backendPost(
        `${ENDPOINT_SET_MANAGER_RESPONSABILITY}?idInterview=${idInterview}&idMnagerResponsible=${idMnagerResponsible}`,
      ),
    [backendPost],
  );

  return {
    findInterviewById,
    findActiveInterviewByCpf,
    findValidatePreRegistration,
    save,
    fetchData,
    getFilters,
    getInterviewBoardForCategory,
    getJustificationResultUnfit,
    updateConditionsUse,
    updateBasicData,
    data,
    loading,
    error,
    getNotasRespostas,
    getRespostaUser,
    getListInterviewOfCandidate,
    findLastInterviewByCpfAndModule,
    addHiglight,
    removeHiglight,
    generateCertificate,
    getUrlCertificate,
    certificateDate,
    sendInterviewCertificate,
    getUrlDownloadCertificate,
    verifyHasAnyFilterActive,
    getInterviewByuserAuth,
    findInterviewByAdm,
    findInterviewByIdPublic,
    deleteCertificate,
    validateNewInterviewByExpiredStatus,
    serviceMigrateInterview,
    getRegistrationDataBoard,
    undoDesist,
    realizeDesist,
    addManagerResponsability,
    findInterviewByCpf,
    pendingInterview,
    getLastInterview,
    hasAlertAwaitinAvaliation,
    putEvaluateByCceScore,
    deleteinterview,
    extendInterview,
    updateViewVideoCondition,
    updateAceptedTermCondition,
  };
}
